import { render, staticRenderFns } from "./GoodDetail.vue?vue&type=template&id=34063fd4&scoped=true&"
import script from "./GoodDetail.vue?vue&type=script&lang=js&"
export * from "./GoodDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodDetail.vue?vue&type=style&index=0&id=34063fd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34063fd4",
  null
  
)

export default component.exports